import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import * as httpClient from "../../util/httpClient";
import { useForm } from "react-hook-form";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const UpdateSecurityQuestion = (props: any) => {
    const dispatch = useDispatch();
    const email = useSelector((state: ApplicationState) => (state.forgotPasswordState && state.forgotPasswordState.email ? state.forgotPasswordState.email : ""));
    const [loading, setLoading] = useState(false);
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    const { register, errors, handleSubmit } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const initailAnswerValue: any = {
        answer1: "",
        answer2: "",
        answer3: "",
    };

    const selectedQuestions: any = {
        question1: "",
        question2: "",
        question3: "",
    };

    const [answers, setAnswers] = useState(initailAnswerValue);
    const [questions, setQuestions] = useState(selectedQuestions);
    const [selectedSecurityQuestion, setSelectedSecurityQuestion] = useState(["", "", "", ""]);
    const [dropdownSecurityQuestion, setDropdownSecurityQuestion] = useState([[]]);
    const [questionRequired, setQuestionRequired] = useState(2);
    const [descriptionText, setDescriptionText] = useState("");

    useEffect(() => {
        requestSecurityQuestionList();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const requestSecurityQuestionList = () => {
        const requestBody = {
            email: email,
        };

        setLoading(true);

        httpClient
            .sendRequest("POST", `web/forgot-password/get-security-questions`, requestBody)
            .then((data) => {
                if (data["securityQuestionList"]) {
                    let securityQuestions: string[] = [];
                    data["securityQuestionList"].forEach((item: any) => {
                        securityQuestions.push(item["question"]);
                    });

                    let requiredQuestion = 3;

                    if (data["selectedSecurityQuestion"]) {
                        let userSeectedSecurityQuestion = selectedSecurityQuestion;
                        userSeectedSecurityQuestion[0] =
                            data["selectedSecurityQuestion"][0] !== null ? data["selectedSecurityQuestion"][0] : userSeectedSecurityQuestion[0];
                        setSelectedSecurityQuestion(userSeectedSecurityQuestion);
                        requiredQuestion = 3 - data["selectedSecurityQuestion"].length;
                    }

                    if (requiredQuestion >= 0) {
                        let securityQuestionList: any[] = [];

                        for (let i = 0; i < requiredQuestion; i++) {
                            securityQuestionList.push(securityQuestions);
                        }
                        setDropdownSecurityQuestion(securityQuestionList);
                    }
                    setQuestionRequired(requiredQuestion);
                    UpdateDescriptionText(requiredQuestion);
                }
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
            });
    };

    const praperSecurityQuestionRequest = () => {
        let securityQuestionAnswer: any[] = [];

        for (let i = 1; i <= questionRequired; i++) {
            const answer = {
                Question: questions["question" + i],
                Answer: answers["answer" + i],
            };
            securityQuestionAnswer.push(answer);
        }

        return securityQuestionAnswer;
    };

    const onSubmit = (e: any) => {
        window.addToDataLayer({ event: "Set New Security Question" });

        const securityQuestionAnswer = praperSecurityQuestionRequest();

        if (isAllQuestionsAnswered()) {
            saveSecurityQuestions(securityQuestionAnswer);
        }
    };

    const saveSecurityQuestions = (SecurityQuestionAnswer: any) => {
        const requestBody = {
            SecurityQuestionAnswer,
        };

        setLoading(true);

        httpClient
            .sendRequest("POST", `web/forgot-password/update-security-question`, requestBody)
            .then((data) => {
                setLoading(false);
                if (data["isSuccess"]) {
                    props.history.push("/dashboard");
                }
            })
            .catch(function (error) {
                setLoading(false);
            });
    };

    const handleChange = (e: any, index: number) => {
        e.preventDefault();

        let userSeectedSecurityQuestion = selectedSecurityQuestion;
        userSeectedSecurityQuestion[index] = e.target.value;
        setSelectedSecurityQuestion(userSeectedSecurityQuestion);

        setQuestions({
            ...questions,
            [e.target.name]: e.target.value,
        });
    };

    const answerChange = (e: any) => {
        setAnswers({
            ...answers,
            [e.target.name]: e.target.value,
        });
    };

    const isAllQuestionsAnswered = () => {
        let allQuestionAnswered: boolean = true;
        for (let i = 0; i < questionRequired; i++) {
            const answerIndex = "answer" + (i + 1);
            const questionIndex = "question" + (i + 1);
            allQuestionAnswered = allQuestionAnswered && answers[answerIndex] && questions[questionIndex];
        }
        return allQuestionAnswered;
    };

    const UpdateDescriptionText = (numberOfQuestion: number) => {
        let text =
            "To increase the protection of your account we are requiring {0} additional security question{1}. Your existing security question and answer will be used alongside these.";
        let numberText = "";
        switch (numberOfQuestion) {
            case 1:
                numberText = "one";
                break;
            case 2:
                numberText = "two";
                break;
            case 3:
                numberText = "three";
                break;
            default:
                numberText = "" + numberOfQuestion;
                break;
        }
        setDescriptionText(text.replace("{0}", numberText).replace("{1}", numberOfQuestion > 1 ? "s" : ""));
    };

    return (
        <React.Fragment>
            <main id="l-page-content" aria-labelledby="title-page">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page" tabIndex={-1}>
                                Set Additional Security Questions
                            </h1>
                        </div>
                    </div>

                    <div className="row margin-vertical-xl" id="content">
                        <div className="col-xs">
                            <div className="box box-has-shadow box-xs offset-padding">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="key" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">Set Additional Security Questions</h2>
                                        </div>
                                    </div>

                                    <div className="box-description">
                                        <p>{descriptionText}</p>
                                    </div>
                                </div>

                                <div className={loading ? "loading box-content" : "box-content"}>
                                    <form id="form-set-new-security-question" onSubmit={handleSubmit(onSubmit)}>
                                        {dropdownSecurityQuestion.map((questionList, index) => {
                                            const currentIndex = index + 1;
                                            const answerIndex = "answer" + (index + 1);
                                            const questionIndex = "question" + (index + 1);

                                            return (
                                                <React.Fragment key={index}>
                                                    <div className="form-row " key={"question" + index}>
                                                        <div className="form-label ">
                                                            <label htmlFor={"label-security-question-" + (index + 1)}>
                                                                {"Select Security Question " + (index + 1) + " "}
                                                                <span className="required" title="Mandatory">
                                                                    *
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div className="form-input ">
                                                            <select
                                                                className={errors[questionIndex] ? "status-error inputbox" : "inputbox"}
                                                                id={questionIndex}
                                                                ref={register({
                                                                    required: true,
                                                                })}
                                                                value={questions[questionIndex] && questions[questionIndex]}
                                                                name={questionIndex}
                                                                onChange={(e: any) => handleChange(e, currentIndex)}
                                                            >
                                                                <option value={""}>- Select Question -</option>
                                                                {questionList.map((question, index) => {
                                                                    return (
                                                                        <option
                                                                            key={question + questionIndex + index}
                                                                            value={question}
                                                                            disabled={
                                                                                selectedSecurityQuestion.includes(question) &&
                                                                                selectedSecurityQuestion[currentIndex] !== question
                                                                            }
                                                                        >
                                                                            {question}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="form-row " key={"answer" + index}>
                                                        <div className="form-label sr-only">
                                                            <label htmlFor={"label-security-question-" + (index + 1) + "-answer"}>
                                                                Select Security Question{" "}
                                                                <span className="required" title="Mandatory">
                                                                    *
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div className="form-input ">
                                                            <input
                                                                aria-labelledby="security_answer_label"
                                                                type="text"
                                                                className={errors[answerIndex] ? "status-error inputbox" : "inputbox"}
                                                                defaultValue={answers[answerIndex] && answers[answerIndex]}
                                                                name={answerIndex}
                                                                id={answerIndex}
                                                                placeholder="Answer"
                                                                onChange={(e: any) => answerChange(e)}
                                                                ref={register({
                                                                    required: true,
                                                                    maxLength: 100,
                                                                })}
                                                                maxLength={100}
                                                            />

                                                            {errors[answerIndex] && errors[answerIndex].type === "required" && (
                                                                <span className="form-error">
                                                                    <p>Answer is required</p>
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}

                                        <div className="margin-vertical-xl"></div>

                                        <div className="form-row">
                                            <button type="submit" className="btn-default btn-primary btn-min-width">
                                                <span className="btn-text">Submit</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </React.Fragment>
    );
};

export default UpdateSecurityQuestion;
